import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AnalyticsState, DashboardStats, EventAnalytics, ProjectAnalytics } from './analyticsTypes';
import { analyticsAPI } from './analyticsAPI';

const initialState: AnalyticsState = {
  dashboardStats: null,
  eventAnalytics: null,
  projectAnalytics: null,
  recentEvents: [],
  loading: false,
  error: null,
};

const analyticsSlice = createSlice({
  name: 'analytics',
  initialState,
  reducers: {
    clearAnalyticsError: (state) => {
      state.error = null;
    },
    resetAnalytics: (state) => {
      state.dashboardStats = null;
      state.eventAnalytics = null;
      state.projectAnalytics = null;
      state.recentEvents = [];
    },
  },
  extraReducers: (builder) => {
    // Get Dashboard Stats
    builder.addMatcher(
      analyticsAPI.endpoints.getDashboardStats.matchPending,
      (state) => {
        state.loading = true;
        state.error = null;
      }
    );
    builder.addMatcher(
      analyticsAPI.endpoints.getDashboardStats.matchFulfilled,
      (state, action) => {
        state.loading = false;
        state.dashboardStats = action.payload;
      }
    );
    builder.addMatcher(
      analyticsAPI.endpoints.getDashboardStats.matchRejected,
      (state, action: any) => {
        state.loading = false;
        state.error = action.error?.message || 'Failed to fetch dashboard stats';
      }
    );
    
    // Get Event Analytics
    builder.addMatcher(
      analyticsAPI.endpoints.getEventAnalytics.matchFulfilled,
      (state, action) => {
        state.eventAnalytics = action.payload;
      }
    );
    
    // Get Project Analytics
    builder.addMatcher(
      analyticsAPI.endpoints.getProjectAnalytics.matchFulfilled,
      (state, action) => {
        state.projectAnalytics = action.payload;
      }
    );
    
    // Get Analytics Events
    builder.addMatcher(
      analyticsAPI.endpoints.getAnalyticsEvents.matchFulfilled,
      (state, action) => {
        state.recentEvents = action.payload;
      }
    );
  },
});

export const { clearAnalyticsError, resetAnalytics } = analyticsSlice.actions;
export default analyticsSlice.reducer;
